module.exports = __webpack_public_path__ + "img/activity_12.98d7d7bf.jpg";